import "./DisplayReplacementPopover.scss";

import { FormattedMessage } from "react-intl";

import { OverlayTrigger, Popover } from "react-bootstrap";
import * as React from "react";

type Props = {
    renderedDeprecatedArticle: React.ReactNode;
};

class DisplayReplacementPopover extends React.Component<Props> {
    renderPopoverReplacement() {
        return (
            <Popover title={<FormattedMessage id="EX_ORDER_HISTORY_LIST_REPLACED_ARTICLE" />} id="replacementPopover">
                <div className="mfcss_card-article-2--grid-container-flex">{this.props.renderedDeprecatedArticle}</div>
            </Popover>
        );
    }

    render() {
        if (this.props.renderedDeprecatedArticle) {
            return (
                <span className="ex-replacement-article-information-links">
                    {", "}
                    <span className="only-visible-on-desktop">
                        <OverlayTrigger
                            trigger="click"
                            placement="bottom"
                            rootClose
                            overlay={this.renderPopoverReplacement()}
                            container={this}>
                            <a>
                                <FormattedMessage id="EX_ORDER_HISTORY_LIST_REPLACEMENT" />
                            </a>
                        </OverlayTrigger>
                    </span>
                    <span className="only-visible-on-mobile">
                        <FormattedMessage id="EX_ORDER_HISTORY_LIST_REPLACEMENT" />
                    </span>
                </span>
            );
        }
        return null;
    }
}

export default DisplayReplacementPopover;
